import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { requireRoute } from '@/router/guards';
import CreateReport from '@/ui/pages/Reports/create/CreateReport';

/**
 * HS-961 / HS-1600: generate a report or create a schedule. The search can prefill the form —
 * `?schedule=true` opens it on the Schedule report type (the Schedules list's "Create report"),
 * `?template=&institutionId=&labId=` preselect the template and scope. Every field `catch`es, so a
 * stale link degrades to an empty form instead of failing the route.
 */
const createReportSearch = z.object({
  schedule: z.coerce.boolean().optional().catch(undefined),
  template: z.string().optional().catch(undefined),
  institutionId: z.string().optional().catch(undefined),
  labId: z.string().optional().catch(undefined),
});

export const Route = createFileRoute('/_dashboard/reports/new')({
  validateSearch: createReportSearch,
  beforeLoad: requireRoute('/reports/new'),
  component: CreateReport,
});
